module.exports = __webpack_public_path__ + "img/nl.f8a06c9b.png";